import type { ProgramEarningsMonthly, ProgramEarningsYearly } from '@/types/eos/ProgramEarningsDashboard'
import axios from 'axios'

export async function getProgramEarningsYearlySummary(siteId: string, year: number): Promise<ProgramEarningsYearly> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/program-earnings/yearly`, {
    params: { site_id: siteId, year },
    timeout: 120_000,
  })
  return response.data
}

export async function getProgramEarningsMonthlySummary(
  siteId: string,
  program: string,
  year: number,
  month: number
): Promise<ProgramEarningsMonthly> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/program-earnings/monthly`, {
    params: { site_id: siteId, program, year, month },
  })
  return response.data
}

export async function exportProgramEarningsMonthlyCSV(
  siteId: string,
  program: string,
  year: number,
  month: number
): Promise<Blob> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/program-earnings/export`, {
    params: { site_id: siteId, program, year, month },
    responseType: 'blob',
  })
  return response.data
}
